/**
 * Local Storage Utils (renamed from utils/local-storage.js)
 * Compression helpers, last-modified check, cache helpers
 */

"use strict";

// Check if debug mode is enabled (global)
const urlParams = new URLSearchParams(window.location.search);

export function lastModified(url, cachedDate = null) {
    let result = null;
    const headers = {};
    
    // Send If-Modified-Since header if we have cached date
    if (cachedDate) {
        // Convert timestamp to HTTP date string format
        // Use toUTCString() which returns format: "Tue, 04 Nov 2025 21:00:36 GMT"
        const date = new Date(cachedDate);
        const dateStr = date.toUTCString();
        headers['If-Modified-Since'] = dateStr;
        
        if (window.HyperLog && debugMode === '1') {
            window.HyperLog.debug('[lastModified] Sending If-Modified-Since', {
                cachedDate: cachedDate,
                dateStr: dateStr,
                timestamp: date.getTime()
            });
        }
    }
    
    $.ajax({
        url: url,
        type: "HEAD",
        async: false,
        headers: headers,
        success: function(data, status, xhr) {
            // If server returned 304, data hasn't changed - return cached date
            if (xhr.status === 304 && cachedDate) {
                result = cachedDate;
                if (window.HyperLog && debugMode === '1') {
                    window.HyperLog.debug('[lastModified] Received 304 Not Modified');
                }
                return;
            }
            
            const lastMod = xhr.getResponseHeader("Last-Modified");
            if (lastMod) {
                result = new Date(lastMod).getTime();
                if (window.HyperLog && debugMode === '1') {
                    window.HyperLog.debug('[lastModified] Received Last-Modified', {
                        header: lastMod,
                        timestamp: result,
                        status: xhr.status
                    });
                }
            }
        },
        error: function(xhr) {
            // If 304 Not Modified, use cached date
            if (xhr.status === 304 && cachedDate) {
                result = cachedDate;
                if (window.HyperLog && debugMode === '1') {
                    window.HyperLog.debug('[lastModified] Received 304 Not Modified (error handler)');
                }
                return;
            }
            
            if (debugMode === '1') {
                console.log('Error getting Last-Modified header', xhr.status);
            }
        }
    });
    return result;
}

export function zipObject(obj) {
    try {
        const str = JSON.stringify(obj || {});
        const compressed = pako.deflateRaw(str, { to: 'string' });
        return btoa(compressed);
    } catch (_) { return ''; }
}

export function zip(data) {
    if (typeof data !== 'string') {
        data = JSON.stringify(data);
    }
    const compressed = pako.deflate(data, { to: 'string' });
    return btoa(compressed);
}

export function unzip(input) {
    try {
        if (!input || typeof input !== 'string') { return []; }
        if (input.length === 0) { return []; }
        try { atob(input); } catch (_) { return []; }
        let compressedData = Uint8Array.from(atob(input), (c) => c.charCodeAt(0));
        if (compressedData.length === 0) { return []; }
        let decompressedData;
        try {
            decompressedData = pako.inflateRaw(compressedData, { to: "string" });
        } catch (e1) {
            try {
                decompressedData = pako.inflate(compressedData, { to: "string" });
            } catch (e2) {
                try {
                    decompressedData = pako.ungzip(compressedData, { to: "string" });
                } catch (e3) {
                    return [];
                }
            }
        }
        if (!decompressedData || decompressedData.length === 0) { return []; }
        try { return JSON.parse(decompressedData) || []; } catch (_) { return []; }
    } catch (_) { return []; }
}

export function clearLocalStorage() {
    try {
        for (const key in window.localStorage) {
            window.localStorage.removeItem(key);
        }
    } catch (e) {}
}

$.urlParam = function(param) {
    return urlParams.get(param);
};


